import {
  TextureLoader,
  RepeatWrapping,
  LinearSRGBColorSpace,
  SRGBColorSpace,
} from 'three'
import { textureConfig } from './textureConfig'

const textureLoader = new TextureLoader()
const baseURL = 'https://3dassets.royalbotania.com/materials'

function constructTextureURL(materialData, resolution, type) {
  return `${baseURL}/${materialData.code}/${resolution}/${materialData.code}-${type.toLowerCase()}-${textureConfig[resolution]}.png`
}

export const unloadTextures = (materialKey, materialsMap) => {
  const [key, value] =
    [...materialsMap.entries()].find(
      ([, value]) => value.material.code === materialKey,
    ) || []

  if (value) {
    Object.entries(value.textures).forEach(([textureKey, textureValue]) => {
      if (textureValue) {
        //console.log(`🗑️ Unloading texture: ${textureKey}`)
        textureValue.dispose()
      }
    })

    materialsMap.delete(key)
    //console.log(`🗑️ Removed material: ${materialKey} from materialsMap`)
  }
}

export async function loadTexturesFromJSON(materialData, resolution, onError) {
  const textureURLs = {
    colorMap: materialData.mapTypes?.baseColor
      ? constructTextureURL(materialData, resolution, 'basecolor')
      : null,
    normalMap: materialData.mapTypes?.normal
      ? constructTextureURL(materialData, resolution, 'normal')
      : null,
    roughnessMap: materialData.mapTypes?.roughness
      ? constructTextureURL(materialData, resolution, 'roughness')
      : null,
    opacityMap: materialData.mapTypes?.opacity
      ? constructTextureURL(materialData, resolution, 'opacity')
      : null,
    metalnessMap: materialData.mapTypes?.metalness
      ? constructTextureURL(materialData, resolution, 'metalness')
      : null,
  }

  // Load all textures in parallel
  const textures = await Promise.allSettled([
    loadTexture(textureURLs.colorMap, SRGBColorSpace, false, onError),
    loadTexture(textureURLs.normalMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.roughnessMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.opacityMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.metalnessMap, LinearSRGBColorSpace, false, onError),
  ])

  // Create an object mapping texture names to their loaded instances or null
  const loadedTextures = {
    colorMap: textures[0].status === 'fulfilled' ? textures[0].value : null,
    normalMap: textures[1].status === 'fulfilled' ? textures[1].value : null,
    roughnessMap: textures[2].status === 'fulfilled' ? textures[2].value : null,
    opacityMap: textures[3].status === 'fulfilled' ? textures[3].value : null,
    metalnessMap: textures[4].status === 'fulfilled' ? textures[4].value : null,
  }

  return loadedTextures
}
const loadTexture = (url, colorSpace, flipY = false, onError) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      resolve(null)
      return
    }
    textureLoader.load(
      url,
      (texture) => {
        texture.wrapS = texture.wrapT = RepeatWrapping
        texture.colorSpace = colorSpace
        texture.flipY = flipY
        resolve(texture)
      },
      undefined,
      (error) => {
        console.warn('Texture loading error:')
        onError && onError(error)
        reject('Texture loading error')
      },
    )
  })
}
